/** WizzyChat: catálogo mínimo para Help Center y UI (solo español). */
const locales = {
  es: 'Español',
};

export default locales;
